import { Alert, Box, Stack, Toolbar, alpha } from '@mui/material';
import useOffSetTop from '@hooks/useOffSetTop';
import useResponsive from '@hooks/useResponsive';
import { HEADER } from '~/config';
import Logo from '@components/Logo';
import Heading from '~/components/Heading';
import { FC, useState } from 'react';
import { RootStyle, styles } from './styles';
import AccountPopoverContainer from './account-popover';
import { apiClient } from '~/api/client';
import { useQuery } from 'react-query';

type Props = {
  connectionName?: string;
  isCollapse?: boolean;
  isError?: boolean;
  isLicenseNational?: boolean;
  isMasquerade: boolean;
  name?: string;
  verticalLayout?: boolean;
  title?: string;
};

const DashboardHeader: FC<Props> = ({
  connectionName,
  title,
  isCollapse = false,
  isError = false,
  isLicenseNational = false,
  isMasquerade = false,
  name,
  verticalLayout = false,
}) => {
  const isOffset = useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;
  const isDesktop = useResponsive('up', 'lg');

  const [showBanner, setShowBanner] = useState(false);
  const [message, setMessage] = useState('');

  // TODO: Remove hardcoded query key
  useQuery('banner', () => apiClient.get('/settings', { params: { slug: 'heading_banner' } }), {
    onSuccess: (response) => {
      if (response.data?.value === 'show') {
        setShowBanner(true);
        setMessage(response.data?.payload?.message);
      }
    },
    retry: false,
  });

  return (
    <RootStyle
      isCollapse={isCollapse}
      isOffset={isOffset}
      verticalLayout={verticalLayout}
      isMasquerade={isMasquerade}
    >
      <Toolbar sx={styles.toolbar}>
        {isDesktop && verticalLayout && <Logo sx={styles.logo} />}
        <Heading
          title={title}
          connectionName={connectionName}
          isError={isError}
          isLicenseNational={isLicenseNational}
          name={name}
        />
        <Box sx={styles.indexBox} />
        <Stack direction="row" alignItems="center" spacing={styles.spacing}>
          {showBanner && message && (
            <Alert
              severity="info"
              icon={false}
              variant="outlined"
              sx={{
                backgroundColor: alpha('#FCF1CA', 0.7),
                color: 'warning.main',
                border: 'none',
                py: '4px',
              }}
            >
              {message}
            </Alert>
          )}
          <AccountPopoverContainer />
        </Stack>
      </Toolbar>
    </RootStyle>
  );
};

export default DashboardHeader;
